import { render, staticRenderFns } from "./SubmenuPopper.vue?vue&type=template&id=bd88f0d8&scoped=true&"
import script from "./SubmenuPopper.vue?vue&type=script&lang=js&"
export * from "./SubmenuPopper.vue?vue&type=script&lang=js&"
import style0 from "./SubmenuPopper.vue?vue&type=style&index=0&id=bd88f0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88f0d8",
  null
  
)

export default component.exports